import { render, staticRenderFns } from "./ProjectActorDialogPortfolio.vue?vue&type=template&id=7493f308&scoped=true&"
import script from "./ProjectActorDialogPortfolio.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialogPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialogPortfolio.vue?vue&type=style&index=0&id=7493f308&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493f308",
  null
  
)

export default component.exports